import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { Apis } from "../../lib/Apis";
import { loginSuccess } from "../../redux/slice/authSlice";
import { setStoredUser } from "../../Utils/permissionAccess";

const useLogin = (onLoginSuccess) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const loginUser = async (body) => {
    try {
      const response = await Apis.login(body);
      const payload = response?.data?.data || response?.data || {};
      const user = payload.user;
      const token = payload.token;

      if (!user || !token) {
        Swal.fire({
          title: "Error",
          text: "Invalid email or password!",
          icon: "error",
          confirmButtonText: "OK",
        });
        return false;
      }

      const roles = user.assignedRoles || [];
      const isOnlyRegularUser = roles.length
        ? roles.every((role) => role.name === "user")
        : user.role === "user" || user.role === "User";

      if (isOnlyRegularUser) {
        return Swal.fire({
          title: "Error",
          text: "Access Denied.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }

      localStorage.setItem("token", token);
      setStoredUser(user);
      dispatch(loginSuccess());
      onLoginSuccess?.();

      Swal.fire({
        title: "Success!",
        text: "You have successfully logged in.",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/dashboard");
      });
      return true;
    } catch (error) {
      const errorMessage =
        error.response?.data?.error ||
        error.response?.data?.message ||
        "Something went wrong. Please try again later.";
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    }

    return false;
  };

  return { loginUser };
};

export default useLogin;
